import {
  type DataSourceDefinition,
  type FiltersDefinition,
  type SortingsDefinition,
} from '@factorialco/f0-react'
import { HeadcountJobCatalogSelectorDocument } from 'generated/resources/graphql'
import { type RecordType } from '@factorialco/f0-react'

import { useGraphqlDataSource } from 'modules/core/hooks/useGraphqlDataSource'

export interface JobCatalogOption extends RecordType {
  id: string
  name: string
}

const useHeadcountJobCatalogSource = (): DataSourceDefinition<
  JobCatalogOption,
  FiltersDefinition,
  SortingsDefinition
> => {
  return useGraphqlDataSource(
    {
      document: HeadcountJobCatalogSelectorDocument,
      paginationType: 'infinite-scroll',
      fetchPolicy: 'cache-first',
      perPage: 25,
      search: { enabled: true },
      mapData: (data) =>
        data.jobCatalog.treeLevelsConnection.edges.map(
          (edge): JobCatalogOption => ({
            id: edge.node.uuid,
            name: edge.node.ancestor?.name
              ? `${edge.node.ancestor.name} > ${edge.node.name ?? ''}`
              : (edge.node.name ?? ''),
          })
        ),
      mapPagination: (data) => {
        const connection = data.jobCatalog.treeLevelsConnection
        return {
          total: connection.totalCount ?? 0,
          cursor: connection.pageInfo.endCursor ?? '0',
          hasNextPage: !!connection.pageInfo.hasNextPage,
        }
      },
      mapVariables: ({ pagination }) => ({
        first: pagination?.perPage ?? 25,
        after:
          pagination?.cursor && pagination.cursor !== '0' ? String(pagination.cursor) : undefined,
      }),
    },
    []
  )
}

export default useHeadcountJobCatalogSource
